module.exports = __webpack_public_path__ + "img/9_reinhard_01.f0cd9182.png";